import { createSlice } from "@reduxjs/toolkit";
import {
  ACTIVESELLERMAPPING,
  REGISTEREDSELLERMAPPING,
} from "../../utils/constants";

export const SELLER_STATUS_UPDATE_ACTIONS = {
  APPROVE: "APPROVE",
  CERTIFY: "CERTIFY",
  ON_HOLD: "ON_HOLD",
  REJECT: "REJECT",
  BUILD: "BUILD",
};

const initialState = {
  searchedSellers: [],
  loading: false,
  selectedStatus: 0,
  selectedSellerID: "",

  statuses: [],

  msal: { user: "", token: "", roles: ["#"], user_email: "" },
  currentStatus: "RALL",
  isInput: false,
  page: 0,
  selectedSeller: null,
  rejectionStatuses: [],
  searchTerm: "",
  hasNextPage: true,
  matchingResults: 0,
  contactTypes: [],
  showContact: false,
  contactFormData: {},
  registrationData: {},
  resendInvite: {},
  sellerStatusUpdate: {
    inProgress: false,
    isSuccess: false,
    isError: false,
    actionType: null,
  },
};

const sellerSlice = createSlice({
  name: "seller",
  initialState,
  reducers: {
    setInputMode: (state, action) => {
      state.isInput = false;
    },
    resetAll: (state, action) => {
      state.page = 0;
      state.searchedSellers = [];
      state.selectedSeller = null;
      state.selectedStatus = 0;
      state.sellerStatusUpdate = {
        inProgress: false,
        isSuccess: false,
        isError: false,
        actionType: null,
      };
      // state.searchTerm = "";
    },
    setPage: (state, action) => {
      state.page += 6;
    },
    setSearchedSellers: (state, action) => {
      let data = action.payload.data;

      // data = data.map((item) => ({
      //   ...item,
      //   status_type: STATUSLOOKUP[item.status_type],
      // }));

      // console.log("", state.currentStatus, action.payload?.currentStatus);

      if (action.payload?.searchTerm) {
        state.searchTerm = action.payload.searchTerm;
      }

      if (action.payload.change) {
        state.hasNextPage = data.length === 6;
        state.searchedSellers.push(...data);
      } else {
        if (action.payload.change !== null) {
          state.hasNextPage = data.length === 6;

          state.searchedSellers = data;
          state.page = 0;
        }
      }

      if (
        action.payload?.count !== undefined &&
        action.payload?.count !== null
      ) {
        state.matchingResults = action.payload.count;
      }

      state.loading = action.payload.loading;
      state.isInput = action.payload.isInput;
    },
    getSearchedSellers: (state, action) => {
      state.loading = true;
    },
    setSelectedSellerID: (state, action) => {
      state.selectedSellerID = action.payload.data;
    },
    setSelectedSeller: (state, action) => {
      state.selectedSeller = 
        
        action.payload.data[0]
        
      
    },
    setAllStatuses: (state, action) => {
      // state.statuses = action.payload.data.reduce((acc, curr) => {
      //   console.log("reddd", acc);
      //   Object.keys(STATUSLOOKUP).includes(curr.status_type) &&
      //     acc.push({
      //       ...curr,
      //       status_en: STATUSLOOKUP[curr.status_type],
      //     });
      //   return acc;
      // }, []);
      let rall = 0;
      let aall = 0;
      action.payload.data.forEach((status) => {
        REGISTEREDSELLERMAPPING.forEach((rStatus) => {
          if (status.status_type === rStatus) {
            rall += status.count;
          }
        });
      });
      action.payload.data.forEach((status) => {
        ACTIVESELLERMAPPING.forEach((aStatus) => {
          if (status.status_type === aStatus) {
            aall += status.count;
          }
        });
      });

      const data = action.payload.data.map((status) => {
        if (status.status_type === "RALL") {
          return {
            ...status,
            count: rall,
          };
        } else if (status.status_type === "AALL") {
          return {
            ...status,
            count: aall,
          };
        }
        return status;
      });

      state.statuses = data;
    },
    getRejectionStatuses: () => {},
    setRejectionStatuses: (state, action) => {
      state.rejectionStatuses = action.payload.data;
    },
    patchApproveStatus: () => {},
    patchCertifiedStatus: () => {},
    patchBuildingStatus: () => {},
    patchRejectStatus: () => {},
    patchOnholdStatus: () => {},
    patchReactiveStatus: () => {},
    startSellerStatusUpdate: (state, action) => {
      state.sellerStatusUpdate = {
        inProgress: true,
        isSuccess: false,
        isError: false,
        actionType: action.payload.actionType,
      };
    },
    setSellerStatusUpdateSuccess: (state, action) => {
      state.sellerStatusUpdate = {
        inProgress: false,
        isSuccess: true,
        isError: false,
        actionType: action.payload.actionType,
      };
    },
    setSellerStatusUpdateFailure: (state, action) => {
      state.sellerStatusUpdate = {
        inProgress: false,
        isSuccess: false,
        isError: true,
        actionType: action.payload.actionType,
      };
    },
    resetSellerStatusUpdate: (state) => {
      state.sellerStatusUpdate = {
        inProgress: false,
        isSuccess: false,
        isError: false,
        actionType: null,
      };
    },

    getAllStatuses: () => {},
    getSelectedSeller: (state, action) => {},
    setSellerStatus: () => {},
    setCurrentStatus: (state, action) => {
      state.currentStatus = action.payload.currentStatus;
      state.page = 0;
    },
    setMSALToken: (state, action) => {
      state.msal = action.payload.data;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload.data;
    },
    resetSearchTerm: (state, action) => {
      state.searchTerm = "";
    },
    getContactTypes: () => {},
    setContactTypes: (state, action) => {
      state.contactTypes = action.payload.data;
    },
    saveContactData: (state, action) => {},
    setCurrentContact: (state, action) => {
      state.contactFormData = {
        contactType: action.payload.data.contact_type,
        fullName: action.payload.data.contact_name,
        phoneNumber: action.payload.data.contact_phone,
        email: action.payload.data.contact_email,
        contactId: action.payload.data.contact_id,
      };
      state.showContact = true;
    },
    toggleContact: (state, action) => {
      if (state.showContact) {
        state.contactFormData = {};
      }
      state.showContact = !state.showContact;
    },
    getCSVData: (state, action) => {},
    getRegistrationData: (state, action) => {},
    setRegistrationData: (state, action) => {
      const data = {
        ...action.payload,
        sup: action.payload.pos_type
          .filter((item) => item.support === "supported")
          .sort((a, b) => a.country.localeCompare(b.country)),
        nonsup: action.payload.pos_type.filter(
          (item) => item.support === "non-supported"
        ),
      };

      delete data.pos_type;

      state.registrationData = data;
    },
    saveImplementationData: (state, action) => {},
    getReminderTypes: () => {},
    setReminderTypes: (state, action) => {
      state.reminderTypes = action.payload.data.sort((a, b) => a.days - b.days);
    },

    resendInviteStart: (state, action) => {
      state.loading = true;
    },
    resendInviteSuccess: (state, action) => {
      state.resendInvite = action.payload;
      state.loading = false;
    },
    resendInviteFailure: (state, action) => {
      state.loading = false;
    },
    sellerProfileDelete: () => {},
  },
});

export const {
  getSearchedSellers,
  setSearchedSellers,
  getSelectedSeller,
  setSelectedSeller,
  setSellerStatus,
  setPage,
  setSelectedSellerID,
  getAllStatuses,
  setAllStatuses,
  setMSALToken,
  setCurrentStatus,
  patchApproveStatus,
  patchCertifiedStatus,
  patchBuildingStatus,
  patchOnholdStatus,
  patchReactiveStatus,
  patchRejectStatus,
  startSellerStatusUpdate,
  setSellerStatusUpdateSuccess,
  setSellerStatusUpdateFailure,
  resetSellerStatusUpdate,
  setRejectionStatuses,
  getRejectionStatuses,
  setSelectedStatus,
  resetAll,
  setInputMode,
  resetSearchTerm,
  getContactTypes,
  setContactTypes,
  saveContactData,
  setCurrentContact,
  toggleContact,
  getCSVData,
  getRegistrationData,
  setRegistrationData,
  saveImplementationData,
  getReminderTypes,
  setReminderTypes,
  resendInviteStart,
  resendInviteSuccess,
  resendInviteFailure,
  sellerProfileDelete,
} = sellerSlice.actions;

export default sellerSlice.reducer;
